import {gql} from '@apollo/client';

import {readQuerySafe} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {PlateMapSize} from 'samples/plate-maps/PlateMapConstants';

import {GridSizeQuery, GridSizeQueryVariables} from './__generated/GridSizeQuery';

export const GRID_SIZE_QUERY = gql`
  query GridSizeQuery($boxOrPlateId: StrictString!) @skipAudit @engComponent(name: INVENTORY) {
    storable(id: $boxOrPlateId) {
      ... on StorableInterface {
        id
        storableSchema {
          ... on StorableSchemaInterface {
            id
          }
          ... on GridSchemaInterface {
            height
            width
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export function getGridDimensionsFromGQLCache(boxOrPlateId: string): PlateMapSize | null {
  const data = readQuerySafe<GridSizeQuery, GridSizeQueryVariables>(
    {
      query: GRID_SIZE_QUERY,
    },
    {
      variables: {boxOrPlateId},
      fetchPolicy: 'cache-only',
    }
  );

  if (data == null) {
    return null;
  }

  // Checks to make Typescript happy
  if (
    data.storable.__typename === 'PlateNode' &&
    data.storable.storableSchema.__typename === 'PlateSchemaNode'
  ) {
    return {
      numRows: data.storable.storableSchema.height,
      numColumns: data.storable.storableSchema.width,
    };
  }

  if (data.storable.__typename === 'BoxNode' && data.storable.storableSchema.__typename === 'BoxSchemaNode') {
    return {
      numRows: data.storable.storableSchema.height,
      numColumns: data.storable.storableSchema.width,
    };
  }

  return null;
}
